import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowUpOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../../../../../store/stores.js";
import { __ } from "../../../../../utils/i18n.js";
const SubscriptionContextualCta = observer(({ subscription })=>{
    const { accountV2Store } = useStores();
    if (subscription.isPastDue) {
        return /*#__PURE__*/ _jsx(Button, {
            type: "primary",
            onClick: ()=>accountV2Store.openChangePaymentFor(subscription),
            children: __("Update payment method")
        });
    }
    // Show the Upgrade affordance whenever the subscription is in a shape
    // that can in principle change plan
    if (subscription.canBeModified && subscription.isActive && !subscription.isOneTime && !subscription.isCancellationPending) {
        return /*#__PURE__*/ _jsx(Button, {
            type: "primary",
            icon: /*#__PURE__*/ _jsx(ArrowUpOutlined, {}),
            onClick: ()=>accountV2Store.openChangePlanFor(subscription, {
                    autoSelectFirstUpgrade: true
                }),
            children: __("Upgrade")
        });
    }
    return null;
});
export { SubscriptionContextualCta };
